export { default } from "./HDSpinner";
